import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo";

// Signed-in buyer requirement posting: private demand data, never indexed.
export const Route = createFileRoute("/_app/buyer/requirements")({
  head: () =>
    buildHead({
      title: "Post a Steel Requirement | LohaLink",
      description:
        "Post your steel or scrap requirement and get quotes from GST-verified sellers.",
      canonical: "/buyer/requirements",
      noindex: true,
    }),
  component: lazyRouteComponent(() => import("@/pages/BuyerRequirements")),
});
